import { useIntl } from 'react-intl';

/**
 * Custom hook to check if a translation exists for a given message id.
 *
 * This hook uses the `intl` object provided by the `useIntl` hook from `react-intl`
 * to format a message. If the formatted message is not equal to the message id,
 * it means the translation exists.
 *
 * @returns {Function} - A function that takes a message id and returns a boolean
 * indicating whether the translation exists.
 */
const useTranslationExists = () => {
  const intl = useIntl();
  return (id: string) => {
    const message = intl.formatMessage({ id });
    return message !== id;
  };
};

export default useTranslationExists;
